export const MY_TEAM_PLAYLISTS_GATE = 'Academy:MyTeam:Playlists';